import { Table } from '@devexpress/dx-react-grid-material-ui'
import { CircularProgress } from '@mui/material'
import React from 'react'

const NoDataCellWithLoading = (props) => {
    const { loading, getMessage: _getMessage, ...restProps } = props
    return loading ? (
        <Table.Cell {...restProps} rowSpan={5} style={{ textAlign: 'center', padding: '50px 0' }}>
            <CircularProgress />
        </Table.Cell>
    ) : (
        <Table.NoDataCell {...restProps} getMessage={() => 'No data'} />
    )
}
export default NoDataCellWithLoading
